import { combineReducers } from 'redux';
import authReducer from './Reducer/auhtReducer';
import citasReducer from './Reducer/citasReducer';
import projectReducer from './Reducer/ProyectReducer';
import reviewReducer from './Reducer/reviewReducer';
import aiReducer from './Reducer/aiReducer';

const rootReducer = combineReducers({
  auth: authReducer,
  citas: citasReducer,
  projects: projectReducer,
  reviews: reviewReducer,
  ai: aiReducer,
});

export default rootReducer;
